import React from 'react'
import ReactDOM from 'react-dom/client'
import { languageReady } from './i18n'
import App from './App'
import './index.css'

// Register service worker for PWA support (production only — in dev mode the SW
// intercepts Vite's module requests and serves stale cached responses)
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  navigator.serviceWorker.register('/sw.js').catch(() => {
    // Service worker registration failed, app will still work offline to a lesser degree
  })
}

// In dev mode, unregister any leftover service worker so it stops intercepting requests
if ('serviceWorker' in navigator && import.meta.env.DEV) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister()
    }
  })
}

// The first render waits for the starting language, so a language other than
// English never shows English first (i18n.ts). English is bundled: no wait.
void languageReady.then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
})
